import { Permission, PlatformFeature } from 'api'
import { createSelector } from '@reduxjs/toolkit'
import { createPlatformFeatureEnabledSelector } from 'selectors/platformSelectors'
import { createUserHasPermissionSelector, isAdminGatewayUserSelector } from 'selectors/userSelectors'

export const startConsiderationOverrideEnabledSelector = createSelector(
  createPlatformFeatureEnabledSelector(PlatformFeature.ENABLE_START_CONSIDERATION_OVERRIDE),
  createUserHasPermissionSelector(Permission.START_CONSIDERATION_OVERRIDE),
  isAdminGatewayUserSelector,
  (platformHasScFeatureEnabled, userHasScFeatureEnabled, isAdminGatewayUser) =>
    (platformHasScFeatureEnabled && userHasScFeatureEnabled) || isAdminGatewayUser
)

export const isStockBorrowingLendingEnabledSelector = createSelector(
  createUserHasPermissionSelector(Permission.STOCK_BORROWING_LENDING),
  isAdminGatewayUserSelector,
  (userHasScFeatureEnabled, isAdminGatewayUser) => userHasScFeatureEnabled || isAdminGatewayUser
)

export const isEvergreenNoticeEnabledSelector = createPlatformFeatureEnabledSelector(PlatformFeature.ENABLE_EVERGREENS)
